import { AxiosResponse } from 'axios';

import { IUser } from '../../shared/ts/user';
import httpRequest from '../httpRequest';

const userAPI = {
  getUserIdByToken: async (): Promise<IUser> => {
    /* in here token is already passed via axios interceptor */
    const { data } = (await httpRequest({
      url: `/user`,
      method: 'POST',
    })) as AxiosResponse;

    return data.data;
  },
  getUserById: async (id: number): Promise<IUser> => {
    const { data } = (await httpRequest({
      url: `/user/${id}`,
      method: 'GET',
    })) as AxiosResponse;

    return data.data;
  },
  updateUserById: async (id: number, payload: IUser): Promise<IUser> => {
    const { data } = (await httpRequest({
      url: `/user/${id}`,
      method: 'PUT',
      data: payload,
    })) as AxiosResponse;

    return data.data;
  },
  updateUserPassword: async (payload: {
    old_password: string;
    new_password: string;
  }): Promise<{ status: number; message: string }> => {
    const { data } = (await httpRequest({
      url: `/user/update-user-password`,
      method: 'POST',
      data: payload,
      baseURL: process.env.REACT_APP_DALGONA_GW_API_URL,
    })) as AxiosResponse;

    return data;
  },
};

export default userAPI;
